// extracted by mini-css-extract-plugin
export var background = "bY_gf";
export var body = "bY_fQ";
export var button = "bY_b7";
export var card = "bY_dp";
export var content = "bY_V";
export var footer = "bY_gg";
export var header = "bY_gd";
export var subtitle = "bY_fV";
export var title = "bY_bl";